import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appOnlyLetters]',
  standalone: false
})
export class OnlyLettersDirective {
  @Input() allowedLetters: string | null = null;
  @Input() allowedChars: string | null = null;

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event']) onInput(event: Event) {
    this.filterValue();
  }

  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const pastedText = event.clipboardData?.getData('text') || '';
    const filteredText = this.getFilteredText(pastedText);
    this.el.nativeElement.value = filteredText;
  }

  private filterValue() {
    const inputElement = this.el.nativeElement as HTMLInputElement;
    inputElement.value = this.getFilteredText(inputElement.value);
  }

  private getFilteredText(value: string): string {
    const allowedPattern = this.getAllowedPattern();
    return value
      .split('')
      .filter((char) => allowedPattern.test(char))
      .join('');
  }

  private getAllowedPattern(): RegExp {
    let pattern = '\\p{L}'; // Domyślnie: wszystkie litery w Unicode

    if (this.allowedLetters) {
      pattern = this.escapeRegExp(this.allowedLetters);
    }

    if (this.allowedChars) {
      pattern += this.escapeRegExp(this.allowedChars);
    }

    return new RegExp(`^[${pattern}]*$`, 'u');
  }

  private escapeRegExp(value: string): string {
    return value.replace(/[-[\]{}()*+?.,\\^$|#]/g, '\\$&');
  }
}
